/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUrl } from './ApiUrl';
import { ApiUrlFromJSON, ApiUrlFromJSONTyped, ApiUrlToJSON, ApiUrlToJSONTyped } from './ApiUrl';
import type { ApiParameter } from './ApiParameter';
import {
  ApiParameterFromJSON,
  ApiParameterFromJSONTyped,
  ApiParameterToJSON,
  ApiParameterToJSONTyped,
} from './ApiParameter';
import type { ApiResourceReference } from './ApiResourceReference';
import {
  ApiResourceReferenceFromJSON,
  ApiResourceReferenceFromJSONTyped,
  ApiResourceReferenceToJSON,
  ApiResourceReferenceToJSONTyped,
} from './ApiResourceReference';

/**
 *
 * @export
 * @interface ApiPipelineVersion
 */
export interface ApiPipelineVersion {
  /**
   * Output. Unique version ID. Generated by API server.
   * @type {string}
   * @memberof ApiPipelineVersion
   */
  id?: string;
  /**
   * Optional input field. Version name provided by user.
   * @type {string}
   * @memberof ApiPipelineVersion
   */
  name?: string;
  /**
   * Output. The time this pipeline version is created.
   * @type {Date}
   * @memberof ApiPipelineVersion
   */
  created_at?: Date;
  /**
   * Output. The input parameters for this pipeline.
   * @type {Array<ApiParameter>}
   * @memberof ApiPipelineVersion
   */
  parameters?: Array<ApiParameter>;
  /**
   * Input. Optional. The URL to the code source of the pipeline version.
   * The code is usually the Python definition of the pipeline and potentially
   * the related component definitions. This allows users to trace back to how
   * the pipeline YAML was created.
   * @type {string}
   * @memberof ApiPipelineVersion
   */
  code_source_url?: string;
  /**
   *
   * @type {ApiUrl}
   * @memberof ApiPipelineVersion
   */
  package_url?: ApiUrl;
  /**
   * Input field. Specify which resource this pipeline version belongs to.
   * For Experiment, the only valid resource reference is a single Namespace.
   * @type {Array<ApiResourceReference>}
   * @memberof ApiPipelineVersion
   */
  resource_references?: Array<ApiResourceReference>;
  /**
   * Input. Optional. Description for the pipeline version.
   * @type {string}
   * @memberof ApiPipelineVersion
   */
  description?: string;
}

/**
 * Check if a given object implements the ApiPipelineVersion interface.
 */
export function instanceOfApiPipelineVersion(value: object): value is ApiPipelineVersion {
  return true;
}

export function ApiPipelineVersionFromJSON(json: any): ApiPipelineVersion {
  return ApiPipelineVersionFromJSONTyped(json, false);
}

export function ApiPipelineVersionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPipelineVersion {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    parameters:
      json['parameters'] == null
        ? undefined
        : (json['parameters'] as Array<any>).map(ApiParameterFromJSON),
    code_source_url: json['code_source_url'] == null ? undefined : json['code_source_url'],
    package_url: json['package_url'] == null ? undefined : ApiUrlFromJSON(json['package_url']),
    resource_references:
      json['resource_references'] == null
        ? undefined
        : (json['resource_references'] as Array<any>).map(ApiResourceReferenceFromJSON),
    description: json['description'] == null ? undefined : json['description'],
  };
}

export function ApiPipelineVersionToJSON(json: any): ApiPipelineVersion {
  return ApiPipelineVersionToJSONTyped(json, false);
}

export function ApiPipelineVersionToJSONTyped(
  value?: ApiPipelineVersion | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    name: value['name'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    parameters:
      value['parameters'] == null
        ? undefined
        : (value['parameters'] as Array<any>).map(ApiParameterToJSON),
    code_source_url: value['code_source_url'],
    package_url: ApiUrlToJSON(value['package_url']),
    resource_references:
      value['resource_references'] == null
        ? undefined
        : (value['resource_references'] as Array<any>).map(ApiResourceReferenceToJSON),
    description: value['description'],
  };
}
